import { IModalActionTypes } from "action/interfaces/modal.interface";

export interface IModalReducer {
  data: any;
  selectedId?: string | null;
  // selectedId should be enum
}

const initialState: IModalReducer = {
  data: {},
  selectedId: null,
};

const modalReducer = (state = initialState, action: IModalActionTypes): IModalReducer => {
  switch (action.type) {
  case "OPEN_MODAL":
    return {
      ...state,
      selectedId: action.data.id,
      data: action.data.modalData,
    };
  case "CLOSE_MODAL":
    return { ...initialState };

  default:
    return state;
  }
};

export default modalReducer;
